import { Box } from "@mui/material";
import { GridSortModel } from "@mui/x-data-grid";
import { useMemo, useState, useCallback } from "react";
import { TablePage } from "src/shared/components/Table";
import { useGetTargetingSettingsListQuery } from "../model/api/api";
import { getColumns } from "../model/constants/columns";
import {
  ITargetingSetting,
  TTargetingSettingModalMode,
} from "../model/types/types";
import { TableHeader } from "./TableHeader";
import { TargetingSettingModal } from "./TargetingSettingModal";

export const TargetingCountries = () => {
  const [search, setSearch] = useState("");

  const [sortModel, setSortModel] = useState<GridSortModel>([
    {
      field: "is_active",
      sort: "desc",
    },
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [modalMode, setModalMode] =
    useState<TTargetingSettingModalMode>("create");

  const [selectedSetting, setSelectedSetting] =
    useState<ITargetingSetting | null>(null);

  const { data, isFetching } = useGetTargetingSettingsListQuery();

  const handleOpenCreateModal = () => {
    setModalMode("create");
    setSelectedSetting(null);
    setIsModalOpen(true);
  };

  const handleOpenEditModal = useCallback((row: ITargetingSetting) => {
    setModalMode("edit");
    setSelectedSetting(row);
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedSetting(null);
  }, []);

  const rows = useMemo(() => {
    const sourceRows = data?.data ?? [];
    const normalizedSearch = search.trim().toLowerCase();

    if (!normalizedSearch) {
      return sourceRows;
    }

    return sourceRows.filter((row) =>
      row.country.name.toLowerCase().includes(normalizedSearch),
    );
  }, [data?.data, search]);

  const columns = useMemo(
    () => getColumns(handleOpenEditModal),
    [handleOpenEditModal],
  );

  return (
    <>
      <Box sx={{ height: "100%" }}>
        <TablePage<ITargetingSetting>
          title={<TableHeader onAddClick={handleOpenCreateModal} />}
          tableSearchModel={{
            value: search,
            onSearch: setSearch,
          }}
          columns={columns}
          rows={rows}
          loading={isFetching}
          paginationMode="client"
          hideFooterPagination
          disableRowSelectionOnClick
          disableColumnSelector
          getRowId={(row) => row.id}
          sortModel={sortModel}
          onSortModelChange={setSortModel}
          localeText={{
            noRowsLabel: "Нет данных",
          }}
        />
      </Box>

      <TargetingSettingModal
        open={isModalOpen}
        mode={modalMode}
        selectedSetting={selectedSetting}
        onClose={handleCloseModal}
      />
    </>
  );
};
